import React, {ReactNode} from 'react';
import {Slide} from 'react-awesome-reveal';
import FeatureWrap from "./FeatureWrap";
import Section from "./Section";
import {stABOUT_US} from "./NavBar";

interface SubsectionProps {
    children: ReactNode;
    className?: string|undefined;
}

export const Subsection: React.FC<SubsectionProps> = ({children, className}) => {
    return (<>
            <br/>
            <Slide direction={'up'} triggerOnce={true}>
                <div className={className} style={{
                    margin: '20px 0',
                    maxWidth: '800px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}>
                    {children}
                </div>
            </Slide>
        </>
    );
};

const AboutUs: React.FC = () => {
    return (
        <Section id={stABOUT_US}>
            <div>
                <h1>About Us</h1>
                <p>EquiQuill.com is an exciting and innovative application that brings a twist of entertainment
                    to your daily journaling habits. Our app is designed to foster a fun and interactive experience
                    that encourages you to reflect, grow, and express yourself authentically. We are a small, dedicated
                    team, driving this project.</p>
            </div>
            <Subsection>
                <h2>Why EquiQuill.com?</h2>
                <p><strong>Not Just Another Journaling App:</strong> In a sea of journaling applications, we
                    stand out
                    by offering a unique experience. Many apps are either prohibitively expensive or lack
                    features that
                    truly enhance your journaling journey.</p>

                <p><strong>Journaling That Matters:</strong> We believe in the importance of journaling as a
                    therapeutic
                    and reflective practice. Handwriting and scripting can be profoundly therapeutic, and
                    we're on a
                    mission to make it accessible in a digital format.</p>

                <p><strong>AI-Enhanced Perspective:</strong> Our app leverages AI to provide an outside view,
                    helping
                    you gain insights into your thoughts and emotions. It facilitates a deeper understanding
                    of your
                    experiences, fostering personal growth.</p>

                <p><strong>Keeping You Honest:</strong> EquiQuill.com is designed to encourage authenticity and
                    honesty
                    in your journaling. Our AI companion will prompt introspection and self-awareness.</p>

            </Subsection>
            <Subsection>
                <h2>Mission</h2>
                <p>To improve the lives of our users through simple, quick and engaging daily habits.</p>

            </Subsection>
            <Subsection>
                <h2>Vision</h2>
                <p>EquiQuill will be the go-to platform for daily reflection and growth, mindfulness,
                    positivity, and
                    courage. EquiQuill will provide a supportive and engaging space for honest
                    self-expression and act
                    as a gateway when needed to broader wellness resources.</p>

            </Subsection>
            <Subsection>
                <h2>Our Commitment to Privacy and Security</h2>
                <p>Despite our size, we take privacy and security incredibly seriously. At this early stage, we
                    are
                    committed to building a foundation of trust with our users by prioritizing the
                    protection of your
                    data. Trust is paramount to us, and we want you to feel confident using our app.</p>

                <p>Rest assured that even as a small team, we are actively investing in and implementing robust
                    security
                    measures to ensure the integrity and confidentiality of your information. Your privacy
                    and data
                    security are fundamental to our mission, and we are continually working to strengthen
                    our security
                    protocols and compliance practices.</p>

                <p>We appreciate your support as we grow and improve our app. Your feedback and trust are
                    invaluable as
                    we strive to provide you with a secure, reliable, and pleasurable experience.</p>

            </Subsection>
            <Subsection>
                <h2>A Note of Caution</h2>
                <p>While we believe in the potential impact of journaling on mental well-being, we want to
                    emphasize
                    that we are not psychologists or psychiatrists. EquiQuill.com is intended for
                    entertainment purposes
                    only. If you have serious mental health concerns, please seek professional guidance and
                    support.</p>

                <p>Thank you for being an early adopter and for accompanying us on this exciting journey of
                    growth and
                    development. We look forward to serving you as we continue to evolve and enhance our
                    application.</p>

            </Subsection>
            <Subsection>
                <h2>Our Team</h2>
                <p>Our team consists of highly qualified and motivated professionals, who are all experts in
                    their
                    field. With many years of experience in the industry, they have the expertise to provide
                    comprehensive, first-rate services to our clients.</p>
                <FeatureWrap title={(<>
                    <h3 style={{marginTop: '-10px'}}>Marc Brazeau</h3>
                    Founder
                </>)}
                             content={'Software developer at heart, with close to thirty years of IT experience in varying roles, Marc is currently working as a software development manager for a large Canadian healthcare software provider, developping new and creative solutions that will revolutionize mental health in Canada.  His passions include cycling, and other self-care habbits (such as journaling, and gratitude) that have had a significant impact on his life.'}
                             imgSize={150}
                             img={'marc.jpg'}
                />
                <FeatureWrap title={(<>
                    <h3 style={{marginTop: '-10px'}}>Marika Brazeau</h3>
                    Marketing
                </>)}

                             imgSize={150}
                             content={'A dedicated student, currently finishing her business undergrad, with a focus in health analytics, information systems management, and psychology, she brings a youthful perspective to our team. Marika\'s role is grounded in practical marketing expertise, where she applies her skills to connect and relate with users effectively. '}
                             img={'marika.jpg'}
                />
            </Subsection>
            <Subsection>
                <h2>EquiQuill in 30 seconds</h2>
                <p>Find out more about EquiQuill in this quick thirty seconds "elevator pitch"</p>
                <iframe src="https://www.youtube-nocookie.com/embed/scxdT_3y1Z8" title="EquiQuill in 30 seconds"
                        width={560} height={315}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen></iframe>
                <br/>
            </Subsection>
        </Section>
    );
};

export default AboutUs;